import styled, { css } from 'styled-components';

import { LoadingButton } from '../../../../../components/Button';

import colors, { getContrastSafeColor } from '../../../../../styles/colors';

const disabledStyles = css`
  background: ${({ $background }) => $background || colors.shades.gamma10};
  color: ${({ $background, $isDarkTheme }) => getContrastSafeColor(
    $background || colors.shades.gamma10,
    $isDarkTheme ? colors.base.alpha : colors.base.beta,
    $isDarkTheme ? colors.base.beta : colors.base.alpha,
  )};
  opacity: 0.8;
  &:hover {
    background: ${({ $background }) => $background || colors.shades.gamma10};
    opacity: 0.9;
  }
`;

const SubmitButton = styled(LoadingButton)`
  width: 100%;
  background: ${({ $background }) => $background || colors.shades.gamma10};
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  height: 72px;
  text-transform: none;
  font-style: normal;
  font-weight:500;
  font-size: 24px;
  line-height: 17px;

  color: ${({ $background, $isDarkTheme }) => getContrastSafeColor(
    $background || colors.shades.gamma10,
    $isDarkTheme ? colors.base.alpha : colors.base.beta,
    $isDarkTheme ? colors.base.beta : colors.base.alpha,
  )};

  &:disabled {
    ${disabledStyles};
  }
`;

export {
  SubmitButton,
};
